// extracted by mini-css-extract-plugin
export default {"link":"CustomNavLink_link__x5ZpY","link_active":"CustomNavLink_link_active__sc4xk"};